import React, { useEffect, useState } from "react";
import Tab from "../../components/Tab/Tab";
import AllDealers from "./AllDealers";
import Favorite from "./Favorite";
import axios from "../../axios/axios";
import { useSelector } from "react-redux";
import SearchInput from '../../components/SearchInput/SearchInput';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import moment from "moment";

dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1
});

const FormatFilterDate = (dateValue, type, format) => {
  if (dateValue !== undefined) {
    if (type === "week") {
      if (dateValue?.length < 10) {
        const FormattedDate = `${dateValue?.slice(0, 4)}-${Number(dateValue?.slice(5, 7))}th`;
        console.log("WEEK FOMART", dateValue, FormattedDate)

        const startDate = moment(FormattedDate, "YYYY-WW").startOf(type);
        const endDate = moment(FormattedDate, "YYYY-WW").endOf(type);
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      } else {
        const startDate = moment(dateValue, "YYYY-WW").startOf(type);
        const endDate = moment(dateValue, "YYYY-WW").endOf(type);
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      }
    } else if (type === "quarter") {
      const startDate = moment().quarter(dateValue).startOf("quarter");
      const endDate = moment().quarter(dateValue).endOf("quarter");
      return {
        startDate: startDate.format(format),
        endDate: endDate.format(format),
      };
    } else {
      const startDate = moment(dateValue).startOf(type);
      const endDate = moment(dateValue).endOf(type);
      return {
        startDate: startDate.format(format),
        endDate: endDate.format(format),
      };
    }
  }
  return "";
};


const BonusSummary = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [bonusSummary, setBonusSummary] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [bonusSummaryFilters, setbonusSummaryFilters] = useState({
    is_favourite: activeTab,
    weekly: {
      startDate: moment(moment(), "YYYY-WW").startOf("week").format("YYYY-MM-DD"),
      endDate: moment(moment(), "YYYY-WW").endOf("week").format("YYYY-MM-DD"),
    },
    monthly: { startDate: "", endDate: "" },
    quaterly: { startDate: "", endDate: "" },
    yearly: { startDate: "", endDate: "" },
  });
  const settings = useSelector((state) => state.settings);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    setbonusSummaryFilters({ ...bonusSummaryFilters, is_favourite: tabIndex })
    // You can perform any other actions you need when a tab is changed here
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    // Add your search logic here
  };

  const tabs = ["All Dealers", "Favourite"]; // Define your tabs array

  const GetBonusSummary = async () => {
    const resp = await axios.post("/bonus/summary", bonusSummaryFilters);
    if (resp?.status < 400) {
      setBonusSummary(resp.data?.data);
    }
  };

  const UpdateFavouriteStatus = async (id, status) => {
    const resp = await axios.post(`/bonus/summary/favourite/${id}/${status}`);
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      GetBonusSummary();
    }

  }

  useEffect(() => {
    GetBonusSummary();
  }, [activeTab, bonusSummaryFilters]);

  const GetBonusSummaryDetail = async (bonusId, tabId) => {
    navigate("/bonus-summary/detailsummary", {
      state: { bonusId: bonusId, tabId: tabId },
    });
  }


  console.log("INITIALLL", moment(moment(), "YYYY-WW").startOf("week").format("YYYY-MM-DD"))
  return (
    <section className="common_container">
      <header className="common-header flex justify-between">
        <div className="common-header-body">
          <h1>Bonus Summary</h1>
        </div>
        <SearchInput onChange={handleSearchChange} value={searchValue} placeholder="Search Dealer" />
      </header>
      <section>
        <div className="tab-section">
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </div>
        <div className="tab-body-section">
          {activeTab === 0 && (
            <AllDealers
              bonusSummary={bonusSummary}
              bonusSummaryFilters={bonusSummaryFilters}
              setbonusSummaryFilters={setbonusSummaryFilters}
              UpdateFavouriteStatus={UpdateFavouriteStatus}
              GetBonusSummaryDetail={GetBonusSummaryDetail}
            />
          )}
          {activeTab === 1 && <Favorite
            bonusSummary={bonusSummary}
            bonusSummaryFilters={bonusSummaryFilters}
            setbonusSummaryFilters={setbonusSummaryFilters}
            UpdateFavouriteStatus={UpdateFavouriteStatus}
            GetBonusSummaryDetail={GetBonusSummaryDetail}
          />}
        </div>
      </section>
    </section>
  );
};

export default BonusSummary;
